export default "__VITE_ASSET__3ab79003__"